import React from 'react';
import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";


export const PagePuffImage = styled.div.attrs(({ bgImage }) => ({
	bgImage: bgImage ? bgImage : "",
}))`
	flex-basis: 100%;
	width: 100%;
	display: flex;
	align-items: flex-end;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.primary};
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% center;
	background-image: ${(props) => `url(${props.bgImage})`};
	${media.lessThan(breakpoints.ipad)`
		margin-top: 1rem;
	`}

	&:before {
		content: "";
		display: block;
		width: 100%;
		padding-bottom: 56.25%;
	}
`;